import { FC, useMemo } from 'react';
import dayjs from 'dayjs';
import { ProTimePicker } from '../antd';
import SimpleFormDisabled from './subpage/disabled';
import SimpleFormItem from './subpage/simpleFormItem';
import {
  BaseSimpleFormProps,
  SimpleFormItemEnum,
  DEFAULT_STYLE,
} from './interface';
import { DETAULT_TIME_FORMAT, TABLE_COLUMN_EMPTY } from '../constants/constant';
import { TimePickerProps } from 'antd/lib/time-picker';

export interface SimpleFormTimePickerProps extends BaseSimpleFormProps {
  timePickerProps?: TimePickerProps;
}
const simpleFormTimePicker: FC<SimpleFormTimePickerProps> = props => {
  const { disabledRender, timePickerProps, form, initialValue, ...restProps } = props;
  const handleRender = (val: any) => {
    if (disabledRender) return disabledRender;
    if (dayjs.isDayjs(val)) {
      // @ts-ignore
      return val.format(timePickerProps?.format || DETAULT_TIME_FORMAT);
    }
    return TABLE_COLUMN_EMPTY;
  };
  const initDayValue = useMemo(() => {
    if (!initialValue || dayjs.isDayjs(initialValue)) return initialValue;
    return dayjs(initialValue);
  }, [initialValue]);

  return (
    <SimpleFormItem {...restProps} initialValue={initDayValue}>
      {timePickerProps?.disabled ? (
        <SimpleFormDisabled
          name={props.name}
          form={form}
          render={handleRender}
        />
      ) : (
        <ProTimePicker
          style={DEFAULT_STYLE}
          format={DETAULT_TIME_FORMAT}
          {...timePickerProps}
        />
      )}
    </SimpleFormItem>
  );
};

simpleFormTimePicker.displayName = SimpleFormItemEnum.SimpleFormTimePicker;

export default simpleFormTimePicker;
